export const loadState = () => {
	try {
		const serializedState = sessionStorage.getItem('idc_state');
		if (serializedState === null) {
			return undefined
		}
		return JSON.parse(serializedState)
	} catch (err) {
		return undefined
	}
};

const exclusions = [
  'appSettingReducer',
  'mfaReducer',
  'resetReducer',
];

export const saveState = (state) => {
	try {
    // Exclude certain reducers from being saved to sessionStorage
    const filteredState = Object.keys(state).reduce((acc, key) => {
      if (!exclusions.includes(key)) {
        acc[key] = state[key];
      }
      return acc;
    }, {});

		const serializedState = JSON.stringify(filteredState);
		sessionStorage.setItem('idc_state', serializedState);
	} catch (err) {
		console.log(err);
	}
}
